import { render, staticRenderFns } from "./ChatsContainer.vue?vue&type=template&id=f8fba150&scoped=true"
import script from "./ChatsContainer.vue?vue&type=script&lang=js"
export * from "./ChatsContainer.vue?vue&type=script&lang=js"
import style0 from "./ChatsContainer.vue?vue&type=style&index=0&id=f8fba150&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fba150",
  null
  
)

export default component.exports